<div class="h-100">
  <router-outlet></router-outlet>

  <do-loader
    [show]="loaderStore.isLoading()"
    [messages]="loaderStore.customLoadingMessages() || []"
  ></do-loader>
</div>
